module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_research-71719cbcafefbaf0b3c92010cb97bb49.svg";